import { Component } from '@angular/core';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/app/app.component.ts